import React from "react";
import project1 from "../../assests/project1.png";
import project2 from "../../assests/project2.png";
import project3 from "../../assests/project3.png";
import Project from "./Project";

const Projects = () => {
  const myProjects = [
    {
      id: 1,
      image: project1,
      name: "Alpha Steelwork",
      point1: "Tools manufacture factory website.",
      point2: "Upon login/signUp, a jsonwebtoken is issued from the server.",
      point3: "implemented admin & user level functionalities.",
    },
    {
      id: 2,
      image: project2,
      name: "Webster Car Warehouse",
      point1: "Car depot managing website.",
      point2: "Users can add a car and see or delete it on my cars route.",
      point3: "All vital information is saved in the database",
    },
    {
      id: 3,
      image: project3,
      name: "Visa Plus",
      point1: "Independent service provider website.",
      point2: "implemented email-password authentication.",
      point3: "Vital information is saved via protected variables.",
    },
  ];

  return (
    <section className="py-12 min-h-screen">
      <div className="bg-white w-11/12 mx-auto py-12">
        <h3 className="text-5xl text-center text-secondary font-BebasNeue pb-12">
          Projects
        </h3>
        <div className="grid grid-cols-1 justify-items-center gap-4 lg:grid-cols-3">
          {myProjects.map((project, index) => (
            <Project key={index} project={project}></Project>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
